import axios from 'axios';

const state = {
  compositeDataset: {},
};

const getters = {
  compositeDataset: (stateTree) => stateTree.compositeDataset,
};
const headers = {
  // withCredentials: false,
  // live
  // 'api-key-id': 'cc4cdff2-1b10-4f9f-9e25-9f3105368b71',
  // 'api-key-secret': '2e52dcc1d17e56e8ffdb1ad6adc72e448118d7575d95e85aff0d974bba9d602b',
  // staging
  // "api-key-id": "bbfe1699-1a0b-4d06-8121-5e05f9ca581c",
  // "api-key-secret": "$2a$10$hcWFZQW7Mx3pUlS0YJc5oegyJckEg1yjUqQK8oACcoz7udSM3P0xe",
  // origins: "https://dashboards.usmart.io"
};
// https://data.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/compoundDataset?view&compoundDatasetGUID=4417ae16-6592-4efe-943a-e0d507b5689a
const actions = {
  async fetchComposite(context) {
    const response = await axios.get(
      'https://data.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/compoundDataset?view&compoundDatasetGUID=4417ae16-6592-4efe-943a-e0d507b5689a',
      {
        headers,
      },
    );
    const data = {};
    data.mapDatasets = [];
    const { dataset } = response.data.result; // array of datasets
    dataset.forEach((result) => {
      const { datasetGUID, resourceContainers } = result;
      const apiResources = resourceContainers.filter(
        (resource) => resource.pipeline.label === 'Plain API',
      );
      const apiResource =
        apiResources.length > 0 ? apiResources[0].resources[0].resourceGUID : null;
      switch (result.lutDataType.id) {
        case 6:
          data.cycleToSchoolDataset = {
            title: 'Children cycling to school',
            label:
              'percentage of children who answered "cycle" when asked the question "How do you normally travel to school?"',
            dataset:
              'https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/85110c9a-7ba6-4c80-8b93-9f9e4f2a790f',
            datasetGUID: '85110c9a-7ba6-4c80-8b93-9f9e4f2a790f',
            apiResource: '786226a3-3570-48c6-ae97-8693caf036a2',
          };
          // data.cycleToSchoolDataset = {
          //   title: 'Hands Up Scottish Survey',
          //   label: 'Cycling Rates',
          //   dataset: 'http://localhost:8080/org/ut/discovery/discovery-view-detail/3aebda37-45d4-4080-8b67-a4a1355370bd',
          //   datasetGUID: '3aebda37-45d4-4080-8b67-a4a1355370bd',
          //   apiResource: '0a9bbd15-826f-406e-a970-e2816cdbf3c0',
          // };
          break;
        case 7:
          data.safetyStatisticsDataset = {
            title: 'Reported Cycling Casualties',
            label: 'Numbers of cyclists slightly injured, seriously injured and killed on roads',
            dataset:
              'https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/0cfbd2c0-5487-4096-8162-73311c71290f',
            datasetGUID: '0cfbd2c0-5487-4096-8162-73311c71290f',
            apiResource: '6cbb5aa3-f572-4935-9a6d-42d15ee4d567',
          };
          // data.safetyStatisticsDataset = {
          //   title: 'Safety Statistics',
          //   label: 'Safety Statistics from 2009 - 2019',
          //   dataset:
          //     'http://localhost:8080/org/ut/dataset/view-edit?datasetGUID=561dfaca-981c-4ba4-9827-9e17be1801cb',
          //   datasetGUID: '561dfaca-981c-4ba4-9827-9e17be1801cb',
          //   apiResource: '51f836bd-979d-4e5e-9cb2-a3ed985dbc47',
          // };
          break;
        case 8:
          data.modeshareDataset = {
            title: 'Modal share of cycling journeys',
            label: 'Percentage of total journeys, work journeys less than 5 miles made by bike',
            dataset:
              'https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/d2355ba5-ab91-48ff-baec-571303566b71?',
            datasetGUID: 'd2355ba5-ab91-48ff-baec-571303566b71',
            apiResource: '8a5c5728-e113-4a77-9795-271618238861',
          };
          // data.modeshareDataset = {
          //   title: 'Modal Share of Journeys',
          //   label: 'Modal Share of Journeys % breakdown',
          //   dataset:
          //     'http://localhost:8080/org/ut/dataset/view-edit?datasetGUID=66047ed5-d111-45a8-9781-fad64e07db04',
          //   datasetGUID: '66047ed5-d111-45a8-9781-fad64e07db04',
          //   apiResource: 'cd790b66-5dfa-4c5a-9258-e1ff5fd57567',
          // };
          break;
        case 9:
          data.attitudesDataset = {
            title: 'Barriers to cycling',
            label: 'Top six reasons given for not cycling to work in',
            dataset:
              'https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/5ca328fd-e93f-4f0e-ab25-bbdcb316259d',
            datasetGUID: '5ca328fd-e93f-4f0e-ab25-bbdcb316259d',
            apiResource: '199df168-e705-41f2-925a-f0c8cbd2031b',
          };
          // data.attitudesDataset = {
          //   title: 'Attitudes of Public Towards Cycling - Travel and Transport',
          //   label: 'Attitudes of Public Towards Cycling',
          //   dataset:
          //     'http://localhost:8080/org/ut/discovery/discovery-view-detail/9120f347-fe05-44c6-aaed-91d7845b514f',
          //   datasetGUID: '9120f347-fe05-44c6-aaed-91d7845b514f',
          //   apiResource: '1ef4113f-b9de-4d1f-93e0-5b165124e027',
          // };
          break;
        case 10:
          data.cycleRouteInformation = {
            title: 'Vehicle free cycle routes',
            label:
              'Length in miles of cycle route that does not have to be shared with vehicles (per 10,000 people)',
            dataset:
              'https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/26010e81-0756-49ea-97bd-9dcfe1b6ea8e',
            datasetGUID: '26010e81-0756-49ea-97bd-9dcfe1b6ea8e',
            apiResource: '415f390a-c64c-4f28-898f-5d0757aa7105',
          };
          // data.cycleRouteInformation = {
          //   title: 'Cycle Route Information',
          //   label: 'Route information by location',
          //   dataset: 'http://localhost:8080/org/ut/dataset/view-edit?datasetGUID=9b0c3eb7-e0d6-49bf-99f3-d960fe2b88f8',
          //   datasetGUID: '9b0c3eb7-e0d6-49bf-99f3-d960fe2b88f8',
          //   apiResource: '3fa3c35c-546f-465c-9f35-515b6106bb8f',
          // };
          break;
        case 11:
          data.top5UsuallyCyclingDataset = {
            title: result.title,
            label: result.lutDataType.label,
            dataset: `https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/${datasetGUID}`,
            datasetGUID,
            apiResource,
          };
          break;
        case 12:
          data.mapDatasets.push({
            title: result.title,
            label: result.lutDataType.label,
            dataset: `https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/${datasetGUID}`,
            datasetGUID,
            apiResource,
          });
          // });
          break;
        case 13:
          data.mapDatasets.push({
            title: result.title,
            label: result.lutDataType.label,
            dataset: `https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/${datasetGUID}`,
            datasetGUID,
            apiResource,
          });
          break;
        case 14:
          data.mapDatasets.push({
            title: result.title,
            label: result.lutDataType.label,
            dataset: `https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/${datasetGUID}`,
            datasetGUID,
            apiResource,
          });
          break;
        case 15:
          data.mapDatasets.push({
            title: result.title,
            label: result.lutDataType.label,
            dataset: `https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/${datasetGUID}`,
            datasetGUID,
            apiResource,
          });
          break;
        case 16:
          data.mapDatasets.push({
            title: result.title,
            label: result.lutDataType.label,
            dataset: `https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/${datasetGUID}`,
            datasetGUID,
            apiResource,
          });
          break;
        default:
          console.error('dataset in compositie does not match required ID number');
      }
    });
    context.commit('setCompositeDataset', JSON.parse(JSON.stringify(data)));
    // return data;
  },
};

const mutations = {
  setCompositeDataset(stateTree, data) {
    stateTree.compositeDataset = { ...data };
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
